__turbopack_context__.v({
  "cardSideEdu": "XFKQ_W_cardSideEdu",
  "cardSideExp": "XFKQ_W_cardSideExp",
  "categoryDivider": "XFKQ_W_categoryDivider",
  "detailsPanel": "XFKQ_W_detailsPanel",
  "detailsPanelOpen": "XFKQ_W_detailsPanelOpen",
  "fadeSlide": "XFKQ_W_fadeSlide",
  "timelineItem": "XFKQ_W_timelineItem",
});
